export const isGuest = (state) => {
  return state.entities.users.isGuest;
};
